import React, {
  FunctionComponent as FC,
  useRef,
  useEffect,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { actionCreators } from "../../../../state";
import { State } from "../../../../state";
import { GrantViewTypes } from "../../../../types/data";
import "./index.scss";
import type { RadioChangeEvent } from 'antd';
import { Spin, Switch, ConfigProvider, Form, Select, Input, Tabs, Radio, Slider, Row, Col, Button } from "antd";
import { CheckOutlined } from '@ant-design/icons';
import * as d3 from "d3";
import _ from "lodash";

import Panel from "../../common/Panel";
import { themeColor, grantViewStyle } from "../../../../types/style.global";
import { CitationFlowType, ImpactType } from "../../../../types/data.global";
import { GlobalStyle } from "../../../../types/style.d";
import BarChart from "../../common/Visualization/BarChart";
import Scatterplot from "../../common/Visualization/Scatterplot";
import ChartUnit from "../ImpactEntityView/ChartUnit";


interface GrantViewProps {
  viewParam: GlobalStyle.ViewSize;
  panelParam: GlobalStyle.PanelStyle;
  viewName: string;
}

const GrantView: FC<GrantViewProps> = (props) => {
  const { viewParam, panelParam, viewName } = props;
  const { Search } = Input;
  const numOfGrantTopicL0 = 50
  const numOfGrantTopicL1 = 168

  const dispatch = useDispatch()
  const {
    getGrantViewData,
    getGrantIdListUsingGrantField,
    updateGrantViewLoading,
  } = bindActionCreators(actionCreators, dispatch)

  const {
    // clear all state variables when click confirm button
    clearMainViewData,
    updateCitationFlowType,
    updateImpactType,
    updateImpactStatisticsTypeList,
    setShowEntityFieldLevelGraph,
    setShowEntityTypeLevelGraph,
    // updateIsEntityFieldGraphFinished,
    updateIsInitializeBubbleTreemapFinished,
    updateIsOptimizedBubbleTreemapFinished,
    updateIsEntityTypeGraphFinished,
    cleanMainviewGraph,
    clearCheckboxSelection,
    updateSelectedImpactEntityField,
    onClickGrantFieldNode,
    onClickImpactFieldNode,
    updateHighlghtedGrantFieldID,
    isShowLeafNode,
    isShowPredictionFlow,
    isShowHistoricalFlow,
    isShowHistoricalGraph,
    isShowPredictionGraph,

    updateEntityTypeLayoutData,
    updateLeafNodeSizeScale,
    updateLeafNodeInitialPositionList,
    updateBubbleTreemapEntityGroupList,
    updateBubbleTreemapGeometryGroup,
    updateWordlePosition,
    updateWordleEntity,
    isShowWordle,
    updatePredictionSearchResult,
    updatePredictionGrantIDList4PIView,
    updateLeafNodePositionList,
    updateEntityFieldGraph_InputData,
    updateGrantFieldNodePosition,
    updateNodePositionList,
  } = bindActionCreators(actionCreators, dispatch)

  // data reducer
  const grantIDList: string[] = useSelector((state: State) => state.dataReducer?.grantIDList) as string[]
  const grantViewScatterplotGrantIDList: string[] = useSelector((state: State) => state.dataReducer?.grantViewScatterplotGrantIDList) as string[]
  const grantViewFunderBarChartData: GrantViewTypes.BarChartDataUnit[] = useSelector((state: State) => state.dataReducer?.grantViewFunderBarChartData) as GrantViewTypes.BarChartDataUnit[]
  const grantViewFunderTimelineData: GrantViewTypes.TimelineEntity[] = useSelector((state: State) => state.dataReducer?.grantViewFunderTimelineData) as GrantViewTypes.TimelineEntity[]
  const grantViewFieldBarChartData: GrantViewTypes.BarChartDataUnit[] = useSelector((state: State) => state.dataReducer?.grantViewFieldBarChartData) as GrantViewTypes.BarChartDataUnit[]
  const grantViewFieldTimelineData: GrantViewTypes.TimelineEntity[] = useSelector((state: State) => state.dataReducer?.grantViewFieldTimelineData) as GrantViewTypes.TimelineEntity[]
  const grantViewScatterplotData: GrantViewTypes.ScatterplotDataUnit[] = useSelector((state: State) => state.dataReducer?.grantViewScatterChartData) as GrantViewTypes.ScatterplotDataUnit[]
  const selectedGrantTopicList: GrantViewTypes.SelectedGrantTopicUnit[] = useSelector((state: State) => state.dataReducer?.selectedGrantTopicList) as GrantViewTypes.SelectedGrantTopicUnit[]
  const isGrantViewLoading: boolean = useSelector((state: State) => state.dataReducer?.isGrantViewLoading) as boolean

  // ui reducer
  const impactType: string = useSelector((state: State) => state.uiReducer?.impactType) as string


  // state variables
  const [radioValue, setRadioValue] = useState('Grant Topic');
  const [isGrantFieldDisplay, setGrantFieldDisplay] = useState("none");
  const [isGrantTopicDisplay, setGrantTopicDisplay] = useState("block");
  const [isGrantFieldLoading, setIsGrantFieldLoading] = useState(false);
  const [isFunderTemporalVisible, setIsFunderTemporalVisible] = useState(false);
  const [isGrantTemporalVisible, setIsGrantTemporalVisible] = useState(false);
  const [topkGrantTopic, setTopkGrantTopic] = useState(numOfGrantTopicL0);


  // 1. function to updateGrantView: call backend to update grant view
  /*
    Description:
      Update the grant view data.
      Triggered anytime when the grantIDList is updated.
    Input Parameters:
      `grantIDList`: list[str]
    Output:
      `grantViewScatterplotData`: list[GrantViewTypes.ScatterplotDataUnit]
      `grantViewFunderBarChartData`: list[GrantViewTypes.BarChartDataUnit]
  */
  const updateGrantView = async () => {
    updateGrantViewLoading(true)
    setIsGrantFieldLoading(true)
    try {
      const result = await getGrantViewData(grantIDList)
    } catch (error) {
      console.error(error);
    } finally {
      updateGrantViewLoading(false)
      setIsGrantFieldLoading(false)
    }
  }

  useEffect(() => {
    // console.log('in GrantView grantViewScatterplotGrantIDList useEffect')
    // if(grantIDList.length > 0){
    //   updateGrantView()
    // }
    updateGrantView()
  }, [grantViewScatterplotGrantIDList])


  // 2. handleConfirmButton: call backend to update all views
  const onConfirmSelectedGrantTopicListClick = () => {
    const grantFieldCodeList: number[] = selectedGrantTopicList.map(item => item.grantFieldCode);

    console.log('=== onConfirmSelectedGrantTopicListClick() === \nselectedGrantTopicList: ', selectedGrantTopicList);
    console.log('grantFieldCodeList: ', grantFieldCodeList);

    // 创建 Promise 确保步骤1先完成
    Promise.resolve()
    .then(() => {
      // 步骤1：清理所有变量和重置到初始状态
      // 1. clear all variables and reset to initial state
      // copy from component <Panel> > `handleChangeImapctTypeDropdown()`
      // ===== copy start =====
      // clear everything then start over again

      // console.log(`selected ${value}`);

      // newly added for this handleConfirmButton(): clean mainview data
      // no need to add this for other two cases: <Panel> > `handleChangeImapctTypeDropdown()`, 右上角view > confirm button  -- 因为不需要去后端重新计算
      clearMainViewData();

      // clear ui reducer: mainview graph
      setShowEntityTypeLevelGraph(false);
      setShowEntityFieldLevelGraph(false);
      updateIsEntityTypeGraphFinished(false);
      isShowHistoricalGraph(true);
      isShowPredictionGraph(false);
      updateHighlghtedGrantFieldID('all');
      isShowLeafNode(true);
      // updateIsEntityFieldGraphFinished(false);
      updateIsInitializeBubbleTreemapFinished(false);
      updateIsOptimizedBubbleTreemapFinished(false);
      cleanMainviewGraph(true);
      isShowWordle(false);
      isShowPredictionFlow(false);
      isShowHistoricalFlow(false);
      updateCitationFlowType(CitationFlowType.HISTORICAL);

      // clear checkbox selection
      updateImpactStatisticsTypeList(['patent', 'clinical_trial', 'policy']); // set to initial state in store
      updateImpactType(ImpactType.INDIRECT_IMPACT_FOLDED); // set to initial state in store

      // clear data reducer: all data stored in redux about mainview calc should be cleared
      updateEntityTypeLayoutData([]);
      updateLeafNodeSizeScale(0, '');
      // store leaf node positions to state - for drawing edges
      updateLeafNodeInitialPositionList({
        leafNodePositionList: [],
        bubbleTreemapEntityTypeCenterXYList: [],
      });
      updateBubbleTreemapEntityGroupList([]);
      updateBubbleTreemapGeometryGroup([]);
      updateWordlePosition({
        left: 0,
        top: 0,
      });
      updateWordleEntity({
        entity: '',
        fieldID: '',
      });
      updateSelectedImpactEntityField({});
      updatePredictionSearchResult({
        entity: '',
        fieldIDList: [],
      });
      updatePredictionGrantIDList4PIView([], []);
      // clear up historical selected (1) citation flow (2) highlight node
      onClickGrantFieldNode({
        grantFieldID: '',
        grantFieldName: '',
        impactType: impactType,
      })
      // clear highlighted impact field node
      onClickImpactFieldNode({
        impactType: '',
        impactEntity: '',
        impactFieldID: '',
      })

      // component: OptimizedBubbleTreemap
      updateLeafNodePositionList({
        leafNodePositionList: [],
        bubbleTreemapEntityTypeCenterXYList: [],
      });
      updateEntityFieldGraph_InputData([]);

      // component: GrantTypeNode
      updateGrantFieldNodePosition({
        grantNodePositionList: [],
        isDrawGrantTypeNodeFinished: false,
      })

      // component: EntityFieldLevelCitationFlow
      updateNodePositionList([]);


      // clear all selection of checkbox
      clearCheckboxSelection(true)
      // ===== copy end =====
    })
    .then(() => {
      // 步骤2：调用后端API更新所有视图
      // 2. call backend API to update all views
      const updateAllViews = async () => {
        try {
          const result = await getGrantIdListUsingGrantField(grantFieldCodeList, grantViewScatterplotGrantIDList)
        } catch (error) {
          console.error(error);
        } finally {
          console.log('Grant View updateAllViews finished');
          // set cleanMainviewGraph to false, to enable default mainview graph
          cleanMainviewGraph(false)
        }
      }
      updateAllViews()
    })
    .catch((error) => {
      console.error('Error in handleConfirmButton:', error);
    });
  };


  // 3. event handlers
  const onRadioChange = ({ target: { value } }: RadioChangeEvent) => {
    setRadioValue(value);
    if(value === 'Grant Field') {
      setGrantFieldDisplay("block");
      setGrantTopicDisplay("none");
    }
    else if(value === 'Grant Topic') {
      setGrantFieldDisplay("none");
      setGrantTopicDisplay("block");
    }
  };
  const toggleFunderBarOrTempView = () => {
    setIsFunderTemporalVisible(!isFunderTemporalVisible);
  };
  const toggleGrantBarOrTempView = () => {
    setIsGrantTemporalVisible(!isGrantTemporalVisible);
  };
  const handleImpactExploreAttrChange = (value: string) => {
    console.log(`handleImpactExploreAttrChange selected ${value}`);
  };
  const handleSearchFieldChange = (value: string) => {
    console.log(`handleSearchFieldChange: ${value}`);
  };
  const onTopicNumSliderChange = (value: number) => {
    console.log('onTopicNumSliderChange: ', value);
    setTopkGrantTopic(value)
  };


  // 4. visualization
  // Responsive visualization size
  const scatterplotParentDivRef = useRef<HTMLDivElement>(null);
  const [scatterplotParentDivSize, setScatterplotParentDivSize] = useState({ width: 0, height: 0 });
  const [scatterplotWidth, setScatterplotWidth] = useState(0);
  const [scatterplotHeight, setScatterplotHeight] = useState(0);
  const resizeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  useEffect(() => {
    if (!scatterplotParentDivRef.current) return;

    const handleResize = (entries: ResizeObserverEntry[]) => {
      // Clear any existing timeout
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }

      // Debounce the resize handling
      resizeTimeoutRef.current = setTimeout(() => {
        if (entries.length === 0) return;

        const entry = entries[0];
        const cr = entry.contentRect;
        const newWidth = cr.width;
        const newHeight = cr.height;

        // Only update if the size actually changed significantly (avoid micro-changes)
        const threshold = 1; // 1px threshold
        const currentSize = scatterplotParentDivSize;

        if (Math.abs(newWidth - currentSize.width) > threshold ||
            Math.abs(newHeight - currentSize.height) > threshold) {

          // Use requestAnimationFrame to batch DOM updates
          requestAnimationFrame(() => {
            setScatterplotParentDivSize({ width: newWidth, height: newHeight });
            setScatterplotWidth(Math.max(0, newWidth));
            setScatterplotHeight(Math.max(0, newHeight));

            setBarChartWidth(Math.max(0, newWidth));
          });
        }
      }, 16); // ~60fps throttling
    };

    // Handle ResizeObserver loop errors
    const ro = new ResizeObserver((entries) => {
      try {
        handleResize(entries);
      } catch (error) {
        // Suppress ResizeObserver loop errors - these are usually benign
        if (error instanceof Error && error.message.includes('ResizeObserver loop')) {
          console.warn('ResizeObserver loop detected, suppressing error');
          return;
        }
        console.error('ResizeObserver error:', error);
      }
    });

    ro.observe(scatterplotParentDivRef.current);

    return () => {
      if (resizeTimeoutRef.current) {
        clearTimeout(resizeTimeoutRef.current);
      }
      ro.disconnect();
    };
  }, [scatterplotParentDivSize.width, scatterplotParentDivSize.height]);
  // console.log('in GrantView, scatterplotParentDivSize: ', scatterplotParentDivSize)
  // console.log('in GrantView, scatterplotWidth: ', scatterplotWidth, 'scatterplotHeight: ', scatterplotHeight)

  // Scatterplot
  // const scatterplotWidth = `calc(${viewSize.grantView.width} - ${viewSize.grantView.padding} * 2)`
  // const scatterplotHeight = `calc(${viewSize.grantView.height} - ${viewSize.grantView.padding} * 2)`
  // const scatterplotWidth = grantViewStyle.scatterplot.width
  // const scatterplotHeight = grantViewStyle.scatterplot.height

  // BarChart
  const [barChartWidth, setBarChartWidth] = useState(0);
  // const barChartWidth = `calc(${viewSize.grantView.width} - ${viewSize.grantView.padding} * 2)`
  // const barChartHeight = `calc(${viewSize.grantView.height} - ${viewSize.grantView.padding} * 2)`
  // const barChartWidth = grantViewStyle.barChart.width
  const barChartHeight = grantViewStyle.barChart.height
  const barChartWithLabelHeight = grantViewStyle.barChart.height + grantViewStyle.barChart.labelMarginBottom
  let funderBarChart: JSX.Element = <></>
  let grantBarChart: JSX.Element = <></>
  funderBarChart = <BarChart width={barChartWidth} height={barChartHeight} heightWithLabel={barChartWithLabelHeight} chartTitle="Funder | subinstitution" data={grantViewFunderBarChartData} />
  grantBarChart = <BarChart width={barChartWidth} height={barChartHeight} heightWithLabel={barChartWithLabelHeight} chartTitle="Grant" data={grantViewFieldBarChartData} />

  // // Timeline
  // const timelineChartWidth = grantViewStyle.timeline.width
  // const timelineChartHeight = grantViewStyle.timeline.height
  // let funderTimelineChart: JSX.Element = <></>
  // let grantTimelineChart: JSX.Element = <></>
  // funderTimelineChart = <SideViewTimeline width={timelineChartWidth} height={timelineChartHeight} chartTitle="Funder | subinstitution" data={grantViewFunderTimelineData} />
  // grantTimelineChart = <SideViewTimeline width={timelineChartWidth} height={timelineChartHeight} chartTitle="Grant" data={grantViewFieldTimelineData} />

  // Tab: Sub-Institution
  const subinstitutionElement: JSX.Element = (
    <div className="grant-field-tab">
      <div className="search-part">
        <Form
          size="middle"
          labelAlign="left"
          layout="horizontal"
          style={{ maxWidth: 300 }}
        >
          {/* <Form.Item label="Impact Explorer Attributes" labelCol={{ span: 16 }} wrapperCol={{ span: 6 }}>
            <Select
              defaultValue="Grant Field"
              style={{ width: 125, height: 25 }}
              onChange={handleImpactExploreAttrChange}
              options={[
                {
                  value: 'Grant Field',
                  label: 'Grant Field',
                },
                {
                  value: 'Test',
                  label: 'Test',
                }
              ]}
            />
          </Form.Item> */}
          {/* <Form.Item label="Search Field" labelCol={{ span: 8 }} wrapperCol={{ span: 14 }}>
            <Search
              placeholder="Search doc by keyword"
              allowClear
              size="small"
              onSearch={handleSearchFieldChange}
              style={{ width: 225, height: 20 }}
            />
          </Form.Item> */}
        </Form>
      </div>
      <ChartUnit title="Funder | subinstitution" isTemporalVisible={isFunderTemporalVisible} toggleTemporalView={toggleFunderBarOrTempView} chart={funderBarChart} />
      {/* <div className="funder-subinstitution-part">
        <div className="title-switch-part">
          <div className="title">Funder | subinstitution</div>
          <div className="temporal-switch">
            <div className="temporal-text">Temporal</div>
            <Switch checked={isFunderTemporalVisible} size="small" onChange={toggleFunderBarOrTempView} />
          </div>
        </div>
          <div style={{ position: 'relative' }}>
            {isFunderTemporalVisible ? (
              <div className="temporal-view" style={{ position: 'absolute', height: "80px", width: "324px"}}>
                {funderTimelineChart}
              </div>
            ) : (
              <div className="barchart-view" style={{ position: 'absolute', height: "80px", width: "324px" }}>
                {funderBarChart}
              </div>
            )}
          </div>
      </div> */}

      <ChartUnit title="Grant Field" isTemporalVisible={isGrantTemporalVisible} toggleTemporalView={toggleGrantBarOrTempView} chart={grantBarChart} />
      {/* <div className="grant-field-part">
        <div className="title-switch-part">
          <div className="title">Grant Field</div>
          <div className="temporal-switch">
            <div className="temporal-text">Temporal</div>
            <Switch checked={isGrantTemporalVisible} size="small" onChange={toggleGrantBarOrTempView} />
          </div>
        </div>
          <div style={{ position: 'relative' }}>
            {isGrantTemporalVisible ? (
              <div className="temporal-view" style={{ position: 'absolute', height: "80px", width: "324px", marginTop:"5px" }}>
                This is the Temporal View.
              </div>
            ) : (
              <div className="barchart-view" style={{ position: 'absolute', height: "80px", width: "324px", marginTop:"5px" }}>
                {grantBarChart}
              </div>
            )}
          </div>
        </div> */}
    </div>
  )

  const handleDownload = () => {
    console.log('download grant meta table');
  }

  return (
    <div className="grant-view-layout-container"> {/* 添加一个新的外层容器，用于定位 */}
      <Panel
        viewTitle={viewName}
        width={viewParam.width}
        height={viewParam.height}
        margin={panelParam.margin}
        padding={panelParam.padding}
        panelHeaderHeight={panelParam.panelHeaderHeight}
      >
        <ConfigProvider
          theme={{
            token:{
              colorPrimary: themeColor.defaultMode.colorPrimary,
            },
            components: {
              Form: {
                labelFontSize: 15,
                itemMarginBottom: 2,
              },
              Radio: {

              }
            }
          }}
        >
            <div className="grant-view">
              <div className="grant-view-radio">
                {/* <Radio.Group
                  onChange={onRadioChange}
                  value={radioValue}
                  optionType="button"
                  size="small"
                >
                  <Radio.Button className="radio-button-grant-topic" value="Grant Topic">Grant Field</Radio.Button>
                  <Radio.Button className="radio-button-grant-field" value="Grant Field">Sub-Institution</Radio.Button>
              </Radio.Group> */}
              </div>

              {/* Tab: Grant Field */}
              <div className="grant-topic-subview" style={{display: isGrantTopicDisplay, width: "100%", height: "100%"}} ref={scatterplotParentDivRef}>
                <Spin tip="Loading" spinning={isGrantViewLoading} size='large'>
                  <div className="grant-topic-silder">
                    {/* <Row style={{display: "flex", justifyContent: "space-between", alignItems: "center", height: "100%"}}>
                      <Col span={16}>
                        <div className="silder-div">
                          <div className="grant-topic-silder-label" style={{textAlign: "right", display: "flex", justifyContent: "center", alignItems: "center", height: "30px"}}>Top K of Topic: </div>
                          <Slider className="silder-slider"
                            max={numOfGrantTopicL0}
                            min={1}
                            defaultValue={numOfGrantTopicL0}
                            onChangeComplete={onTopicNumSliderChange}
                          />
                        </div>
                      </Col>
                      <Col span={8}>
                        <DownloadButton handleDownload={handleDownload} />
                      </Col>
                    </Row> */}
                  </div>
                  <div className="grant-topic-scatterplot">
                    {(scatterplotWidth > 0) &&
                      <Scatterplot
                        width={scatterplotWidth}
                        height={scatterplotHeight}
                        chartTitle="Grant Topic"
                        data={grantViewScatterplotData}
                      />
                    }
                  </div>
                  {/* <div className="grant-topic-button" style={{position: "absolute", right: "4px", bottom: "12px", zIndex: 5}}>
                    <Button shape="circle" icon={<CheckOutlined />} size="small" onClick={onConfirmSelectedGrantTopicListClick}></Button>
                  </div> */}
                </Spin>
              </div>

              {/* Tab: Sub-Institution */}
              <div className="grant-field-subview" style={{display: isGrantFieldDisplay}}>
                <Spin tip="Loading" spinning={isGrantFieldLoading} size='large'>
                  {subinstitutionElement}
                </Spin>
              </div>
            </div>
        </ConfigProvider>
      </Panel>
    </div>
  );
};

export default GrantView;
